import React from "react"
import { OutboundLink } from "gatsby-plugin-gtag"

import Layout from "../components/layout"

export default () => (
  <Layout>
    <h1>Fungears</h1>
    { /* prettier-ignore */ }
    <pre>{`
System failure...............................
Rebooting ...................................
Starting system .............................
Scanning modules: 3 new modules found
Loading modules:
    * Open source intent ........ done
    * Open source transformer.... in progress
    * Open source releaser....... pending

> Please wait until system is ready
    `}

    </pre>
    <div
      dangerouslySetInnerHTML={{
        __html: "<!-- Yes, we are coming back! :) -->",
      }}
    />
  </Layout>
)
